module.exports = __webpack_public_path__ + "static/StoreOwnerS04-722ba5e60e10672be0c57ea6e0f4c8b0.jpg";